module.exports = __webpack_public_path__ + "img/b-logo-3.c6cd27b4.png";